import { NumberUtils } from '@shared/util/number-utils';

export class OverlapInfo {
  public overlapTypes: string[] = [];
  public overlapLeftTypes: string[] = [];
  public overlapRightTypes: string[] = [];

  public overlapLeft: number = 0;
  public overlapRight: number = 0;

  public constructor(overlapTypes: string[] | null = null, overlapLeft: number = NaN, overlapRight: number = NaN,
                     overlapLeftTypes: string[] | null = null, overlapRightTypes: string[] | null = null) {
    if (overlapTypes) {
      this.overlapTypes = overlapTypes;
    } else {
      this.overlapTypes = [];
    }

    if (overlapLeftTypes) {
      this.overlapLeftTypes = overlapLeftTypes;
    } else {
      this.overlapLeftTypes = this.overlapTypes.concat();
    }

    if (overlapRightTypes) {
      this.overlapRightTypes = overlapRightTypes;
    } else {
      this.overlapRightTypes = this.overlapTypes.concat();
    }

    if (NumberUtils.isNumber(overlapLeft)) {
      this.overlapLeft = overlapLeft;
    }
    if (NumberUtils.isNumber(overlapRight)) {
      this.overlapRight = overlapRight;
    }
  }

  public clone(): OverlapInfo {
    return new OverlapInfo(this.overlapTypes, this.overlapLeft, this.overlapRight, this.overlapLeftTypes, this.overlapRightTypes);
  }

  public reverse(): OverlapInfo {
    const overlapInfo: OverlapInfo = new OverlapInfo(this.overlapTypes, this.overlapRight, this.overlapLeft, this.overlapRightTypes, this.overlapLeftTypes);
    this.overlapLeft = overlapInfo.overlapLeft;
    this.overlapRight = overlapInfo.overlapRight;
    this.overlapLeftTypes = overlapInfo.overlapLeftTypes;
    this.overlapRightTypes = overlapInfo.overlapRightTypes;
    return overlapInfo;
  }

  public copyOverlapLeftOnly(): OverlapInfo {
    return new OverlapInfo(
      [...this.overlapLeftTypes],
      this.overlapLeft,
      0,
      [...this.overlapLeftTypes],
      []
    );
  }

  public copyOverlapRightOnly(): OverlapInfo {
    return new OverlapInfo(
      [...this.overlapRightTypes],
      0,
      this.overlapRight,
      [],
      [...this.overlapRightTypes]
    );
  }
}
